<template>
  <main id="clientApply" v-if="config.status.authed">
    <Toolbar
      :item="getItem"
      @select="update"
    />
    <v-progress-linear indeterminate v-if="isInitializaing" class="ma-0" color="blue" />
    <v-container fluid grid-list-md class="pa-0" v-if="!isInitializaing">
      <v-row dense v-if="isSetItem">
        <v-col cols="12" v-if="isRequiredRepublish">
          <p class="caption red--text text-xs-left">申込書発行後に内容の変更がありました。申込書の内容と異なる可能性があります。</p>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card>
            <v-list class="pa-0">
              <v-list-item class="grey lighten-4 grey--text text--darken-3">
                <v-list-item-avatar>
                  <v-icon small>fa-school</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">コース</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                        <v-icon small>fa-bars</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :disabled="isLoading" @click="edit({ type: 'course' })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-plus</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>新規追加する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <v-list-item v-for="(item, idx) in getCourseItems" :key="item.id" class="my-3">
                <v-list-item-avatar color="blue-grey darken-4 white--text">{{ $mango.alphabet[idx % $mango.alphabet.length] }}</v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="caption"><span class="font-weight-bold">レッスン内容：</span>{{ item.lesson.size + item.lesson.unit }}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    <span class="font-weight-bold">期間：</span>
                    <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
                    <span v-if="item.term && item.term.size || item.extra && item.extra.size">
                      {{
                        [
                          '（',
                          [
                            (item.term && item.term.size) ? (item.term.size + item.term.unit) : null,
                            (item.extra && item.extra.size) ? (item.extra.size + item.extra.unit) : null
                          ].filter(it => { return it }).join('+'),
                          '）'
                        ].join('').replace('（）', '')
                      }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                        <v-icon small>fa-ellipsis-v</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :disabled="isLoading" @click="edit({ type: 'course', data: item })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-pencil</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>編集する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item :disabled="isLoading" @click="remove({ type: 'courses', data: item })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-trash-alt</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>削除する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card>
            <v-list class="pa-0">
              <v-list-item class="grey lighten-4 grey--text text--darken-3">
                <v-list-item-avatar>
                  <v-icon small>fa-bed</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">滞在</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                        <v-icon small>fa-bars</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :disabled="isLoading" @click="edit({ type: 'stay' })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-plus</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>新規追加する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <v-list-item v-for="(item, idx) in getStayItems" :key="item.id" class="my-3">
                <v-list-item-avatar color="blue-grey darken-4 white--text">{{ $mango.alphabet[idx % $mango.alphabet.length] }}</v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle class="caption"><span class="font-weight-bold">宿泊タイプ：</span>{{ item.type }}</v-list-item-subtitle>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    <span class="font-weight-bold">期間：</span>
                    <span v-if="item.dates && (item.dates.start + item.dates.end)">{{ (item.dates.start ? $moment(item.dates.start).format('YYYY/MM/DD') : '') + '-' + (item.dates.end ? $moment(item.dates.end).format('YYYY/MM/DD') : '') }}</span>
                    <span v-if="item.term && item.term.size || item.extra && item.extra.size">
                      {{
                        [
                          '（',
                          [
                            (item.term && item.term.size) ? (item.term.size + item.term.unit) : null,
                            (item.extra && item.extra.size) ? (item.extra.size + item.extra.unit) : null
                          ].filter(it => { return it }).join('+'),
                          '）'
                        ].join('').replace('（）', '')
                      }}
                    </span>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                        <v-icon small>fa-ellipsis-v</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :disabled="isLoading" @click="edit({ type: 'stay', data: item })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-pencil</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>編集する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item :disabled="isLoading" @click="remove({ type: 'stays', data: item })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-trash-alt</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>削除する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card>
            <v-list class="pa-0">
              <v-list-item class="grey lighten-4 grey--text text--darken-3">
                <v-list-item-avatar>
                  <v-icon small>fa-clipboard-list</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">委託手配</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-menu bottom left offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn icon small v-on="on" color="secondary" :loading="isLoading">
                        <v-icon small>fa-bars</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item :disabled="isLoading" @click="edit({ type: 'arrangements', data: store.item ? store.item.arrangements : {} })">
                        <v-list-item-avatar>
                          <v-icon small>fal fa-pencil</v-icon>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>編集する</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list>
              <v-list-item class="my-3">
                <v-list-item-avatar>
                  <v-icon small>fal fa-plane</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle v-if="!isFlightEmpty" class="caption">航空手配</v-list-item-subtitle>
                  <v-list-item-title>{{ printFlight }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="my-3">
                <v-list-item-avatar>
                  <v-icon small>fal fa-first-aid</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle v-if="!isInsuranceEmpty" class="caption">保険手配</v-list-item-subtitle>
                  <v-list-item-title>{{ printInsurance }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="my-3">
                <v-list-item-avatar>
                  <v-icon small>fal fa-id-card</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle v-if="!isVisaEmpty" class="caption">査証手配</v-list-item-subtitle>
                  <v-list-item-title>{{ printVisa }}</v-list-item-title>
                  <v-list-item-subtitle v-if="!isVisaTypeEmpty || !isVisaLocalEmpty" class="caption">
                    <span class="font-weight-bold">種類：</span>{{ printVisaType }}
                    <span class="font-weight-bold">{{ printVisaLocal }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item class="my-3">
                <v-list-item-avatar>
                  <v-icon small>fal fa-car-side</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-subtitle v-if="!isPickupEmpty" class="caption">送迎手配</v-list-item-subtitle>
                  <v-list-item-title>{{ printPickup }}</v-list-item-title>
                  <v-list-item-subtitle v-if="printPickupName || printPickupType" class="caption">
                    <span class="font-weight-bold" v-if="printPickupName">送迎者：</span>{{ printPickupName }}
                    <span class="font-weight-bold">{{ printPickupType }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense v-else>
        <v-col cols="12">
          <p class="headline text-xs-center grey--text">申込がございません。【機能】より申込を追加してください。</p>
        </v-col>
      </v-row>
      <CourseModal ref="course" @done="edited"></CourseModal>
      <StayModal ref="stay" @done="edited"></StayModal>
      <ArrangementsModal ref="arrangements" @done="edited"></ArrangementsModal>
    </v-container>
  </main>
</template>

<script>
import Toolbar from './toolbar'
import CourseModal from './modals/course'
import StayModal from './modals/stay'
import ArrangementsModal from './modals/arrangements'
export default {
  name: 'clientApply',
  components: {
    Toolbar,
    CourseModal,
    StayModal,
    ArrangementsModal
  },
  data () {
    return {
      config: {
        status: {
          loading: true,
          authed: false
        }
      },
      meta: {
      },
      store: {
        item: null
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    init: function () {
      this.auth()
    },
    auth: function () {
      let auths = this.$store.getters['author/get']('authority')
      let permit = this.$route.meta.permit
      if (!auths.includes(permit)) {
        this.$router.push('/')
      } else {
        this.$set(this.config.status, 'authed', true)
      }
    },
    get: function (item) {
      if (item && item.id) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}apply/get/item/${item.id}`, {}, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              this.$set(this.store, 'item', Object.assign({
                id: item.id,
                aid: item.aid || '',
                title: item.title || '',
                type: item.type || '',
                country: item.country || '',
                city: item.city || '',
                start: item.start ? item.start.replace('0000-00-00', '') : '',
                end: item.end ? item.end.replace('0000-00-00', '') : '',
                published_at: item.published_at || '',
                modified_at: item.modified_at || '',
                status: item.status || ''
              }, res.data.data))
            }
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    update: function (item) {
      if (item && item.id) {
        this.get(item)
      } else {
        this.$set(this.store, 'item', {})
        this.$set(this.config.status, 'loading', false)
      }
    },
    edit: function (req) {
      const { type, data } = req || {}
      if (type && this.$refs[type]) {
        this.$refs[type].open((data && data.id) ? data : null)
      }
    },
    edited: function (req) {
      const { type, data } = req || {}
      if (
        type && data &&
        this.store.item &&
        this.store.item.id
      ) {
        let fm = req.data
        let action = (data.id && Number.isFinite(data.id)) ? 'update' : 'insert'
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}apply/${action}/meta`, {
            id: data.id,
            cid: this.store.item.id,
            type: type === 'courses' ? 'course' : (type === 'stays' ? 'stay' : type),
            form: fm
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              if (action === 'update') {
                if (type === 'courses') {
                  let idx = this.store.item.courses.findIndex(it => {
                    return it.id === data.id
                  })
                  if (idx >= 0) {
                    this.store.item.courses.splice(idx, 1, fm)
                  }
                } else if (type === 'stays') {
                  let idx = this.store.item.stays.findIndex(it => {
                    return it.id === data.id
                  })
                  if (idx >= 0) {
                    this.store.item.stays.splice(idx, 1, fm)
                  }
                } else if (type === 'arrangements') {
                  this.store.item.arrangements = fm
                }
              } else if (action === 'insert') {
                const nid = res.data.data.id
                if (type === 'courses') {
                  this.store.item.courses.push(Object.assign(fm, { id: nid }))
                } else if (type === 'stays') {
                  this.store.item.stays.push(Object.assign(fm, { id: nid }))
                } else if (type === 'arrangements') {
                  this.store.item.arrangements = Object.assign(fm, { id: nid })
                }
              }
              if (this.store.item.modified_at !== '0000-00-00 00:00:00') {
                this.$set(this.store.item, 'modified_at', res.data.data.modified_at)
              }
            }
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    },
    remove: function (req) {
      const { type, data } = req || { type: '', data: {} }
      const { id } = data
      const cid = this.store.item.id
      if (id) {
        this.$set(this.config.status, 'loading', true)
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(`${this.$url.api}apply/delete/meta`, {
            id, cid
          }, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            this.$set(this.config.status, 'loading', false)
            if (res.data && res.data.success) {
              let idx = this.store.item[type].findIndex(it => { return it.id === id })
              if (idx >= 0) {
                this.store.item[type].splice(idx, 1)
              }
            }
          })
        }).catch(err => {
          console.log(err)
          this.$set(this.config.status, 'loading', false)
        })
      }
    }
  },
  computed: {
    isDeveloping () {
      return this.$store.getters['author/get']('dev')
    },
    isInitializaing () {
      return this.store.item == null
    },
    isLoading () {
      return this.config.status.loading
    },
    isSetItem () {
      return (this.store.item && this.store.item.id)
    },
    isRequiredRepublish () {
      return (
        this.store.item &&
        this.store.item.published_at &&
        this.store.item.modified_at &&
        this.store.item.published_at !== this.store.item.modified_at
      )
    },
    printURL () {
      return 'https://legacy.sasmango.com/sas/client/' + this.$route.params.id + '/apply'
    },
    printTitle () {
      return (
        this.store.item &&
        this.store.item.title
      ) ? this.store.item.title : ''
    },
    printCountry () {
      return (
        this.store.item &&
        this.store.item.country &&
        this.$mango.nations[this.store.item.country]
      ) ? this.$mango.nations[this.store.item.country] : ''
    },
    printCity () {
      return (
        this.store.item &&
        this.store.item.city
      ) ? this.store.item.city : ''
    },
    isFlightEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.flight &&
        this.store.item.arrangements.flight.status
      )
    },
    printFlight () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.flight &&
        this.store.item.arrangements.flight.status
      ) ? this.store.item.arrangements.flight.status : '航空手配'
    },
    isInsuranceEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.insurance &&
        this.store.item.arrangements.insurance.status
      )
    },
    printInsurance () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.insurance &&
        this.store.item.arrangements.insurance.status
      ) ? this.store.item.arrangements.insurance.status : '保険手配'
    },
    isVisaEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.status
      )
    },
    isVisaTypeEmpty () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.type
      )
    },
    isVisaLocalEmpty () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.local
      )
    },
    printVisa () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.status
      ) ? this.store.item.arrangements.visa.status : '査証手配'
    },
    printVisaType () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.type
      ) ? this.store.item.arrangements.visa.type : ''
    },
    printVisaLocal () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.visa &&
        this.store.item.arrangements.visa.local
      ) ? '（現地申請）' : ''
    },
    isPickupEmpty () {
      return !(
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.status
      )
    },
    printPickup () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.status
      ) ? this.store.item.arrangements.pickup.status : '送迎手配'
    },
    printPickupName () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.name
      ) ? this.store.item.arrangements.pickup.name : ''
    },
    printPickupType () {
      return (
        this.store.item &&
        this.store.item.arrangements &&
        this.store.item.arrangements.pickup &&
        this.store.item.arrangements.pickup.type
      ) ? `（${this.store.item.arrangements.pickup.type}）` : ''
    },
    printPublishedAt () {
      return (this.store.item && this.store.item.published_at) ? this.store.item.published_at : false
    },
    printModifiedAt () {
      return (this.store.item && this.store.item.modified_at) ? this.store.item.modified_at : false
    },
    getItem () {
      return this.store.item
    },
    getCourseItems () {
      return (
        this.store.item &&
        this.store.item.courses &&
        this.store.item.courses.length
      ) ? this.store.item.courses : []
    },
    getStayItems () {
      return (
        this.store.item &&
        this.store.item.stays &&
        this.store.item.stays.length
      ) ? this.store.item.stays : []
    }
  }
}
</script>

<style lang="scss">
#clientApply {
  #legacy {
    width: 100%;
    height: 100%;
    iframe {
      display: block;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
}
</style>
